// Mercapoli - Términos y Condiciones
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const TerminosCondiciones = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Términos y Condiciones | Mercapoli</title>
        <meta name="description" content="Consulta los términos y condiciones de uso de la plataforma Mercapoli." />
      </Helmet>

      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="font-heading text-4xl font-bold mb-8 text-center">
            Términos y Condiciones
          </h1>
          
          <p className="text-sm text-muted-foreground text-center mb-12">
            Última actualización: Enero 2026
          </p>

          <div className="prose prose-lg dark:prose-invert mx-auto space-y-8">
            <section>
              <h2 className="font-heading text-xl font-bold mb-4">1. Aceptación de los Términos</h2>
              <p>
                Al acceder y utilizar la plataforma Mercapoli, el usuario acepta cumplir con los 
                presentes Términos y Condiciones. Si no está de acuerdo con alguno de estos términos, 
                le recomendamos no utilizar nuestros servicios.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">2. Naturaleza del Servicio</h2>
              <p>
                Mercapoli actúa como <strong>intermediario tecnológico</strong> entre usuarios, comercios 
                y repartidores, sin asumir responsabilidad directa sobre los productos o servicios 
                entregados por terceros.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">3. Obligaciones del Usuario</h2>
              <p>El usuario se compromete a:</p>
              <ul className="list-disc list-inside space-y-2 mt-4">
                <li>Proporcionar información veraz y actualizada</li>
                <li>Usar la plataforma de manera legal y ética</li>
                <li>Respetar las políticas de uso establecidas</li>
                <li>No realizar actividades fraudulentas</li>
                <li>Mantener la confidencialidad de sus credenciales</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">4. Pagos y Transacciones</h2>
              <p>
                Los pagos realizados a través de la plataforma están sujetos a las políticas de 
                nuestros proveedores de pago. Mercapoli no almacena información sensible de 
                tarjetas de crédito o débito.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">5. Cancelaciones y Reembolsos</h2>
              <p>
                Las políticas de cancelación y reembolso pueden variar según el comercio y el 
                estado del pedido. Consulte los detalles específicos al momento de realizar su orden.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">6. Propiedad Intelectual</h2>
              <p>
                Todo el contenido de la plataforma, incluyendo logos, diseños, textos y código, 
                es propiedad de Mercapoli y está protegido por las leyes de propiedad intelectual.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">7. Modificaciones</h2>
              <p>
                Mercapoli se reserva el derecho de modificar estos términos en cualquier momento. 
                Los cambios serán efectivos desde su publicación en la plataforma.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl font-bold mb-4">8. Contacto</h2>
              <p>
                Para consultas sobre estos términos, puede contactarnos en:
                <br />
                <a href="mailto:soporte@mercapoli.com" className="text-brand-primary hover:underline">
                  soporte@mercapoli.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TerminosCondiciones;
